/**
 * Shared step-action title/description templates.
 * Templates live in the i18n catalog; helpers fill {stepName} for the active locale.
 */

import { tStepTemplate } from '../i18n/translate';

export const TITLE_HOW_TO_WORK_KEY = 'step.action.template.how_to_work.title';
export const TITLE_READ_GUIDANCE_KEY = 'step.action.template.read_guidance.title';
export const TITLE_READ_GREEN_BOOK_KEY = 'step.action.template.read_green_book.title';
export const TITLE_UNDERSTAND_STEP_KEY = 'step.action.template.understand_step.title';

export const DESC_GUIDANCE_AND_VIDEO_KEY = 'step.action.template.guidance_and_video.description';
export const DESC_PRACTICAL_GUIDANCE_KEY = 'step.action.template.practical_guidance.description';
export const DESC_REVIEW_WITH_SPONSOR_KEY = 'step.action.template.review_with_sponsor.description';

export function howToWorkTitle(stepNumber: number): string {
  return tStepTemplate(TITLE_HOW_TO_WORK_KEY, stepNumber);
}

export function readGuidanceTitle(stepNumber: number): string {
  return tStepTemplate(TITLE_READ_GUIDANCE_KEY, stepNumber);
}

export function readGreenBookTitle(stepNumber: number): string {
  return tStepTemplate(TITLE_READ_GREEN_BOOK_KEY, stepNumber);
}

export function understandStepTitle(stepNumber: number): string {
  return tStepTemplate(TITLE_UNDERSTAND_STEP_KEY, stepNumber);
}

export function guidanceAndVideoDescription(stepNumber: number): string {
  return tStepTemplate(DESC_GUIDANCE_AND_VIDEO_KEY, stepNumber);
}

export function practicalGuidanceDescription(stepNumber: number): string {
  return tStepTemplate(DESC_PRACTICAL_GUIDANCE_KEY, stepNumber);
}

export function reviewWithSponsorDescription(stepNumber: number): string {
  return tStepTemplate(DESC_REVIEW_WITH_SPONSOR_KEY, stepNumber);
}
